var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.model && _vm.record && _vm.currentUser
    ? _c(
        "div",
        { staticClass: "mb-4", attrs: { role: "main" } },
        [
          _c("div", { staticClass: "row" }, [
            _c("h1", { staticClass: "col", attrs: { tabindex: "-1" } }, [
              _vm._v(_vm._s(_vm.title))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              !_vm.downloadingPdf
                ? _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top.center",
                          value: {
                            content: _vm.$t("Btn_Pdf_Generic_Description")
                          },
                          expression:
                            "{ content:$t('Btn_Pdf_Generic_Description') }",
                          modifiers: { top: true, center: true }
                        }
                      ],
                      staticClass: "btn btn-secondary float-right",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.generatePdf()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("Btn_Pdf")) + "\n        "
                      ),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(
                          "-. " + _vm._s(_vm.$t("Btn_Pdf_Generic_Description"))
                        )
                      ])
                    ]
                  )
                : _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top.center",
                          value: { content: _vm.$t("Btn_Pdf_Description") },
                          expression: "{ content: $t('Btn_Pdf_Description') }",
                          modifiers: { top: true, center: true }
                        }
                      ],
                      staticClass: "d-inline-block float-right",
                      attrs: { tabindex: "0" }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: {
                            type: "button",
                            disabled: "",
                            "aria-disabled": true
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("Btn_Pdf")) +
                              "\n          "
                          ),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(
                              "-. " +
                                _vm._s(_vm.$t("Btn_Pdf_Generic_Description"))
                            )
                          ])
                        ]
                      )
                    ]
                  )
            ])
          ]),
          _vm._v(" "),
          _vm.isGeneralNotification
            ? _c("h2", [_vm._v(_vm._s(_vm.model.subject))])
            : _vm._e(),
          _vm._v(" "),
          _vm.description
            ? _c("p", { staticClass: "mb-5" }, [
                _vm._v(_vm._s(_vm.description))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.record.createdDate
            ? _c("text-label-row", {
                attrs: {
                  title: "Arrived",
                  bold: true,
                  formatDate: true,
                  noTime: true,
                  value: _vm.record.createdDate
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentUser.organisationName
            ? _c("text-label-row", {
                attrs: {
                  title: "OrganisationName",
                  bold: true,
                  value: _vm.currentUser.organisationName
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentUser.organisationNumber
            ? _c("text-label-row", {
                attrs: {
                  title: "Pdf.OrganisationNumber",
                  bold: true,
                  value: _vm.getStringValue(_vm.currentUser.organisationNumber)
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.record.year
            ? _c("text-label-row", {
                attrs: {
                  title: "Year",
                  bold: true,
                  value: _vm.getStringValue(_vm.record.year)
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.record.aidTargetNumber
            ? _c("text-label-row", {
                attrs: {
                  title: "AidTargetNumber",
                  bold: true,
                  value: _vm.record.aidTargetNumber
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isTransferedAmountNotification
            ? _c("transferred-amount-view", { attrs: { model: _vm.model } })
            : _vm._e(),
          _vm._v(" "),
          _vm.isInspectionVisitNotification
            ? _c("inspection-visit-view", { attrs: { model: _vm.model } })
            : _c("p", {
                staticClass: "mt-5 preformatted",
                domProps: { innerHTML: _vm._s(_vm.model.text) }
              })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }